import { Images } from "@abcya/abcya_phaser";
import GameplayScene from "./scenes/GameplayScene";
import ResultsScene from "./scenes/ResultsScene";
import TitleScene from "./scenes/TitleScene";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [TitleScene, GameplayScene, ResultsScene],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: TitleScene.KEY,
    ss: Images.DEFAULT_ATLAS,
    config: {
        soundMuted: false
    },
    score: 0,
    level: 0,
    totalMade: 0,
    tileLevel: 0
}
